module.exports = __webpack_public_path__ + "static/media/Img-onboarding-tokens-02.8ea52cfd.png";